import base from "@/store/utils/api-route/base";

const metaAPI = {
	// rekeningBank: `${base.masterData}keuangan/list_rekening_owner_with_filter`,
	// rekeningAtasNama: `${base.masterData}keuangan/list_rekening_owner`,
	rekeningBank: {
		getIdAkun: `${base.masterData}keuangan/get_kode_keuangan_rekening`,
		list: `${base.masterData}keuangan/list_rekening_owner_with_filter`,
		detail: `${base.masterData}keuangan/detail_rekening_owner`,
		create: `${base.masterData}keuangan/tambah_rekening_owner`,
		update: `${base.masterData}keuangan/edit_rekening_owner`,
		delete: `${base.masterData}keuangan/hapus_rekening_owner`,
		atasNama: `${base.masterData}keuangan/list_rekening_owner`,
	},
	transferKas: {
		create: `${base.masterData}keuangan/buat_keuangan_transfer`,
		akunKeuangan: `${base.masterData}penggajian/meta/list_akun_keuangan`
	},
	riwayatTransfer: {
		list: `${base.masterData}keuangan/get_riwayat_transfer`,
		detail: `${base.masterData}keuangan/get_detail_riwayat_transfer`,
	}
}

export default metaAPI